import './App.css';
import Navbar from './Navbar';
import EventInfo from './EventInfo';
import Slideshow from './Slideshow';

function App() {
  return (
    <div className="App">
      <Navbar />
      <EventInfo />
      <Slideshow />
    </div>
  );
}

export default App;
